// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.service-page main {
  flex: 1;
}

/* Flipbook Animation */
.service-page .flipbook-section {
  opacity: 0;
  transform: rotateY(-15deg) translateZ(-100px);
  transform-style: preserve-3d;
  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  perspective: 1000px;
}

.service-page .flipbook-section.flipbook-visible {
  opacity: 1;
  transform: rotateY(0deg) translateZ(0);
}

/* Hero Section */
.service-page .service-hero {
  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);
  color: white;
  padding: 6rem 0 4rem;
  position: relative;
  overflow: hidden;
}

.service-page .service-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  z-index: 1;
}

.service-page .service-hero .container {
  position: relative;
  z-index: 2;
}

.service-page .back-link {
  display: inline-flex;
  align-items: center;
  color: #ffbb00;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 2rem;
  transition: transform 0.3s ease, color 0.3s ease;
}

.service-page .back-link:hover {
  transform: translateX(-5px);
  color: #cc9900;
}

.service-page .hero-content {
  max-width: 1000px;
  margin: 0 auto;
}

.service-page .hero-text {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  text-align: center;
}

.service-page .service-category {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 700;
  color: #ffbb00;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 0.5rem 1rem;
  background: rgba(255, 187, 0, 0.1);
  border-radius: 5px;
  width: fit-content;
  margin: 0 auto;
}

.service-page .service-hero h1 {
  font-size: 3.5rem;
  font-weight: 900;
  line-height: 1.1;
  margin: 0;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.service-page .service-icon {
  font-size: 3.5rem;
}

.service-page .service-description {
  font-size: 1.3rem;
  line-height: 1.8;
  color: #e0e0e0;
  margin: 0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.service-page .hero-actions {
  margin-top: 1rem;
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* Section Styles */
.service-page .service-section {
  padding: 5rem 0;
}

.service-page .service-section:nth-child(even) {
  background-color: #f8f8f8;
}

.service-page .service-section h2 {
  font-size: 2.5rem;
  font-weight: 900;
  color: #000;
  margin-bottom: 1.5rem;
  text-align: center;
}

.service-page .section-description {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #333;
  max-width: 900px;
  margin: 0 auto 2rem;
  text-align: center;
}

/* Benefits Section */
.service-page .benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.service-page .benefit-card {
  background: linear-gradient(135deg, #fff 0%, #f8f8f8 100%);
  border-radius: 12px;
  padding: 2rem;
  border: 2px solid rgba(255, 187, 0, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.service-page .benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: #ffbb00;
}

.service-page .benefit-card h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #000;
  margin-bottom: 1rem;
  color: #ffbb00;
}

.service-page .benefit-card p {
  font-size: 1rem;
  line-height: 1.7;
  color: #333;
  margin: 0;
}

/* Features Section */
.service-page .features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 3rem;
}

.service-page .feature-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem;
  background: white;
  border-radius: 8px;
  border-left: 4px solid #ffbb00;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-page .feature-item:hover {
  transform: translateX(5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.service-page .feature-check {
  font-size: 1.5rem;
  color: #ffbb00;
  font-weight: 900;
  flex-shrink: 0;
}

.service-page .feature-text {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
}

/* Technologies Section */
.service-page .technologies-section {
  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);
  color: white;
}

.service-page .technologies-section h2 {
  color: white;
}

.service-page .tech-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
}

.service-page .tech-tag {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  color: #000;
  font-weight: 700;
  border-radius: 25px;
  font-size: 1rem;
  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-page .tech-tag:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.4);
}

/* Use Cases Section */
.service-page .use-cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.service-page .use-case-card {
  background: linear-gradient(135deg, #fff 0%, #f8f8f8 100%);
  border-radius: 12px;
  padding: 2rem;
  border: 2px solid rgba(255, 187, 0, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-page .use-case-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: #ffbb00;
}

.service-page .use-case-card h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #000;
  margin-bottom: 1rem;
}

.service-page .use-case-card p {
  font-size: 1rem;
  line-height: 1.7;
  color: #333;
  margin: 0;
}

/* Process Section */
.service-page .process-steps {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 3rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.service-page .process-step {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
  background: white;
  border-radius: 12px;
  padding: 2rem;
  border: 2px solid rgba(255, 187, 0, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-page .process-step:hover {
  transform: translateX(5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: #ffbb00;
}

.service-page .step-number {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 900;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);
}

.service-page .step-content {
  flex: 1;
}

.service-page .step-content h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #000;
  margin-bottom: 0.75rem;
}

.service-page .step-content p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #333;
  margin: 0;
}

/* Pricing Section */
.service-page .pricing-section {
  background: linear-gradient(135deg, #f8f8f8 0%, #ffffff 100%);
  text-align: center;
}

.service-page .pricing-note {
  font-size: 1rem;
  color: #666;
  font-style: italic;
  margin-top: 1rem;
}

/* CTA Section */
.service-page .service-cta {
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  color: #000;
  padding: 5rem 0;
  text-align: center;
}

.service-page .service-cta h2 {
  font-size: 2.5rem;
  font-weight: 900;
  margin-bottom: 1rem;
  color: #000;
}

.service-page .service-cta p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: #333;
}

.service-page .cta-actions {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* Not Found */
.service-page.service-not-found {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.service-page .not-found-content {
  text-align: center;
  padding: 5rem 2rem;
  max-width: 600px;
  margin: 0 auto;
}

.service-page .not-found-content h1 {
  font-size: 3rem;
  font-weight: 900;
  color: #000;
  margin-bottom: 1rem;
}

.service-page .not-found-content p {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 2rem;
}

/* Responsive Design */
@media (max-width: 992px) {
  .service-page .service-hero h1 {
    font-size: 2.5rem;
  }

  .service-page .service-icon {
    font-size: 2.5rem;
  }

  .service-page .benefits-grid,
  .service-page .use-cases-grid {
    grid-template-columns: 1fr;
  }

  .service-page .process-step {
    flex-direction: column;
    text-align: center;
  }

  .service-page .step-number {
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .service-page .service-hero {
    padding: 4rem 0 3rem;
  }

  .service-page .service-hero h1 {
    font-size: 2rem;
    flex-direction: column;
    gap: 0.5rem;
  }

  .service-page .service-icon {
    font-size: 2rem;
  }

  .service-page .service-description {
    font-size: 1.1rem;
  }

  .service-page .service-section {
    padding: 3rem 0;
  }

  .service-page .service-section h2 {
    font-size: 2rem;
  }

  .service-page .features-grid {
    grid-template-columns: 1fr;
  }

  .service-page .service-cta h2 {
    font-size: 2rem;
  }

  .service-page .cta-actions {
    flex-direction: column;
    align-items: stretch;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/services/ServicePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA,uBAAuB;AACvB;EACE,UAAU;EACV,6CAA6C;EAC7C,4BAA4B;EAC5B,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,0DAA0D;EAC1D,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;GAIC;EACD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,0CAA0C;EAC1C,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".service-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.service-page main {\n  flex: 1;\n}\n\n/* Flipbook Animation */\n.service-page .flipbook-section {\n  opacity: 0;\n  transform: rotateY(-15deg) translateZ(-100px);\n  transform-style: preserve-3d;\n  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  perspective: 1000px;\n}\n\n.service-page .flipbook-section.flipbook-visible {\n  opacity: 1;\n  transform: rotateY(0deg) translateZ(0);\n}\n\n/* Hero Section */\n.service-page .service-hero {\n  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);\n  color: white;\n  padding: 6rem 0 4rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.service-page .service-hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.7) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  z-index: 1;\n}\n\n.service-page .service-hero .container {\n  position: relative;\n  z-index: 2;\n}\n\n.service-page .back-link {\n  display: inline-flex;\n  align-items: center;\n  color: #ffbb00;\n  text-decoration: none;\n  font-weight: 600;\n  margin-bottom: 2rem;\n  transition: transform 0.3s ease, color 0.3s ease;\n}\n\n.service-page .back-link:hover {\n  transform: translateX(-5px);\n  color: #cc9900;\n}\n\n.service-page .hero-content {\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.service-page .hero-text {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  text-align: center;\n}\n\n.service-page .service-category {\n  display: inline-block;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #ffbb00;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 187, 0, 0.1);\n  border-radius: 5px;\n  width: fit-content;\n  margin: 0 auto;\n}\n\n.service-page .service-hero h1 {\n  font-size: 3.5rem;\n  font-weight: 900;\n  line-height: 1.1;\n  margin: 0;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.service-page .service-icon {\n  font-size: 3.5rem;\n}\n\n.service-page .service-description {\n  font-size: 1.3rem;\n  line-height: 1.8;\n  color: #e0e0e0;\n  margin: 0;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.service-page .hero-actions {\n  margin-top: 1rem;\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Section Styles */\n.service-page .service-section {\n  padding: 5rem 0;\n}\n\n.service-page .service-section:nth-child(even) {\n  background-color: #f8f8f8;\n}\n\n.service-page .service-section h2 {\n  font-size: 2.5rem;\n  font-weight: 900;\n  color: #000;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.service-page .section-description {\n  font-size: 1.2rem;\n  line-height: 1.8;\n  color: #333;\n  max-width: 900px;\n  margin: 0 auto 2rem;\n  text-align: center;\n}\n\n/* Benefits Section */\n.service-page .benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.service-page .benefit-card {\n  background: linear-gradient(135deg, #fff 0%, #f8f8f8 100%);\n  border-radius: 12px;\n  padding: 2rem;\n  border: 2px solid rgba(255, 187, 0, 0.2);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.service-page .benefit-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  border-color: #ffbb00;\n}\n\n.service-page .benefit-card h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 1rem;\n  color: #ffbb00;\n}\n\n.service-page .benefit-card p {\n  font-size: 1rem;\n  line-height: 1.7;\n  color: #333;\n  margin: 0;\n}\n\n/* Features Section */\n.service-page .features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  margin-top: 3rem;\n}\n\n.service-page .feature-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1.25rem;\n  background: white;\n  border-radius: 8px;\n  border-left: 4px solid #ffbb00;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.service-page .feature-item:hover {\n  transform: translateX(5px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.service-page .feature-check {\n  font-size: 1.5rem;\n  color: #ffbb00;\n  font-weight: 900;\n  flex-shrink: 0;\n}\n\n.service-page .feature-text {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  color: #333;\n}\n\n/* Technologies Section */\n.service-page .technologies-section {\n  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);\n  color: white;\n}\n\n.service-page .technologies-section h2 {\n  color: white;\n}\n\n.service-page .tech-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.service-page .tech-tag {\n  display: inline-block;\n  padding: 0.75rem 1.5rem;\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  color: #000;\n  font-weight: 700;\n  border-radius: 25px;\n  font-size: 1rem;\n  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.service-page .tech-tag:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.4);\n}\n\n/* Use Cases Section */\n.service-page .use-cases-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.service-page .use-case-card {\n  background: linear-gradient(135deg, #fff 0%, #f8f8f8 100%);\n  border-radius: 12px;\n  padding: 2rem;\n  border: 2px solid rgba(255, 187, 0, 0.2);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.service-page .use-case-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  border-color: #ffbb00;\n}\n\n.service-page .use-case-card h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 1rem;\n}\n\n.service-page .use-case-card p {\n  font-size: 1rem;\n  line-height: 1.7;\n  color: #333;\n  margin: 0;\n}\n\n/* Process Section */\n.service-page .process-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin-top: 3rem;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.service-page .process-step {\n  display: flex;\n  gap: 2rem;\n  align-items: flex-start;\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  border: 2px solid rgba(255, 187, 0, 0.2);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.service-page .process-step:hover {\n  transform: translateX(5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  border-color: #ffbb00;\n}\n\n.service-page .step-number {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  color: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  font-weight: 900;\n  flex-shrink: 0;\n  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);\n}\n\n.service-page .step-content {\n  flex: 1;\n}\n\n.service-page .step-content h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 0.75rem;\n}\n\n.service-page .step-content p {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: #333;\n  margin: 0;\n}\n\n/* Pricing Section */\n.service-page .pricing-section {\n  background: linear-gradient(135deg, #f8f8f8 0%, #ffffff 100%);\n  text-align: center;\n}\n\n.service-page .pricing-note {\n  font-size: 1rem;\n  color: #666;\n  font-style: italic;\n  margin-top: 1rem;\n}\n\n/* CTA Section */\n.service-page .service-cta {\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  color: #000;\n  padding: 5rem 0;\n  text-align: center;\n}\n\n.service-page .service-cta h2 {\n  font-size: 2.5rem;\n  font-weight: 900;\n  margin-bottom: 1rem;\n  color: #000;\n}\n\n.service-page .service-cta p {\n  font-size: 1.2rem;\n  margin-bottom: 2rem;\n  color: #333;\n}\n\n.service-page .cta-actions {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Not Found */\n.service-page.service-not-found {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.service-page .not-found-content {\n  text-align: center;\n  padding: 5rem 2rem;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.service-page .not-found-content h1 {\n  font-size: 3rem;\n  font-weight: 900;\n  color: #000;\n  margin-bottom: 1rem;\n}\n\n.service-page .not-found-content p {\n  font-size: 1.2rem;\n  color: #666;\n  margin-bottom: 2rem;\n}\n\n/* Responsive Design */\n@media (max-width: 992px) {\n  .service-page .service-hero h1 {\n    font-size: 2.5rem;\n  }\n\n  .service-page .service-icon {\n    font-size: 2.5rem;\n  }\n\n  .service-page .benefits-grid,\n  .service-page .use-cases-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .service-page .process-step {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .service-page .step-number {\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .service-page .service-hero {\n    padding: 4rem 0 3rem;\n  }\n\n  .service-page .service-hero h1 {\n    font-size: 2rem;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .service-page .service-icon {\n    font-size: 2rem;\n  }\n\n  .service-page .service-description {\n    font-size: 1.1rem;\n  }\n\n  .service-page .service-section {\n    padding: 3rem 0;\n  }\n\n  .service-page .service-section h2 {\n    font-size: 2rem;\n  }\n\n  .service-page .features-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .service-page .service-cta h2 {\n    font-size: 2rem;\n  }\n\n  .service-page .cta-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
